import { api } from '@/shared/api/client-api'
import { API_END_POINTS } from '@/shared/api/end-points'
import { GetUserSearchParams } from '@/shared/api/end-points/user'
import { ProjectSearchResponse } from '../../lib'

const getUserSearch = async (params: GetUserSearchParams) => {
  return await api.json<ProjectSearchResponse>(API_END_POINTS.user.getUserSearch(params))
}

export default getUserSearch
